<template>
  <footer :class="$style['footer']">
    <NuxtLink to="/" :class="$style['footer__logo']" aria-label="Hengelose Revue, naar de homepage"><Logo /></NuxtLink>
    <address :class="$style['footer__address']">Hengelose Revue, Torenlaan 5-3, 7559 PK Hengelo<br>074 291 8579, secretariaat@hengeloserevue.nl</address>
    <ul :class="$style['footer__links']">
      <li v-for="link in FOOTER_LINKS" :key="link.to">
        <NuxtLink :to="link.to" :class="$style['footer__link']" :target="link.external ? '_blank' : undefined">{{ link.name }}</NuxtLink>
      </li>
    </ul>
  </footer>
</template>
<script setup lang="ts">
const FOOTER_LINKS = [
  { name: 'Kleding huren', to: '/kleding' },
  { name: 'Nieuws', to: '/over-ons/nieuws' },
  { name: 'Veelgestelde vragen', to: '/veelgestelde-vragen' },
  { name: 'Contact', to: '/contact' },
  { name: 'Perskit', to: '/pers-kit' },
  { name: 'Facebook', to: 'https://www.facebook.com/hengeloserevue', external: true },
  { name: 'Instagram', to: 'https://www.instagram.com/hengeloserevue/', external: true }
]
</script>
<style module>
/* Logo with the address underneath on the left, links on the right */
.footer {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-template-areas:
    "logo links"
    "address links";
  align-items: center;
  gap: var(--spacing-l) var(--spacing-xxxl);
  padding: var(--spacing-xxl) var(--stage-gutter);
  background: var(--stage-black);
  color: var(--stage-soft);
  font-size: var(--font-size-small);
}

.footer__logo {
  display: block;
  grid-area: logo;
  width: 9rem;
}

.footer__address {
  grid-area: address;
  font-style: normal;
}

.footer__links {
  grid-area: links;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--spacing-l) var(--spacing-xl);
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer__link {
  color: var(--stage-white);
  text-underline-offset: 0.25em;
}

.footer__link:hover {
  color: var(--primary-color);
}

@media (width <= 64rem) {
  .footer {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
      "logo"
      "links"
      "address";
    justify-items: start;
  }

  .footer__links {
    justify-content: flex-start;
  }
}
</style>
